export default __webpack_public_path__ + "static/media/Behance.2c348536.svg";